import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';

import Button from '@/components/elements/Button';
import ButtonArrow from '@/components/elements/ButtonArrow';
import Container from '@/components/elements/Container';
import Heading from '@/components/elements/Heading';
import PreHeading from '@/components/elements/PreHeading';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface StandardTextLayoutProps {
  blok: any;
  content: any;
}

const StandardTextLayout: FC<StandardTextLayoutProps> = ({ blok }) => {
  switch (blok.mode) {
    case '2-column':
      return (
        <Section {...storyblokEditable(blok)} gapTop="none" gapBottom="none">
          <Container
            size={'wider'}
            className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16 lg:gap-24"
          >
            <div>
              <div className="mr-8 space-y-8">
                <div className="space-y-2">
                  {blok.pre_headline && (
                    <PreHeading
                      dot={true}
                      size="md"
                      element="h2"
                      color="primary"
                      className="font-normal"
                    >
                      {blok.pre_headline}
                    </PreHeading>
                  )}
                  {blok.headline && (
                    <Heading
                      size="md"
                      weight="semi"
                      element={blok.pre_headline ? 'p' : 'h2'}
                    >
                      {blok.headline}
                    </Heading>
                  )}
                </div>
              </div>
              {blok.actions?.length ? (
                <div className="mt-8 flex gap-x-3">
                  {blok.actions.map((action) => (
                    <Button
                      key={action._uid}
                      link={action.link}
                      style={action.style}
                    >
                      <ButtonArrow
                        className={`${action.style} mr-1 -ml-1 h-5 w-6`}
                      />
                      <span className="-mb-0.5">{action.label}</span>
                    </Button>
                  ))}
                </div>
              ) : null}
            </div>

            <div>
              {blok.content && (
                <Prose size={'base'} content={blok.content}></Prose>
              )}
            </div>
          </Container>
        </Section>
      );
    case 'full':
    default:
      return (
        <Section {...storyblokEditable(blok)} className="mb-0" gapTop="none">
          <Container size={'tightest'}>
            <StandardText blok={blok} size={StandardTextSize.MD} />
          </Container>
        </Section>
      );
  }
};

export default StandardTextLayout;
